// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-and-marketing-top .content-description,.media-and-marketing-top .content-description>p{max-width:950px;margin-bottom:30px;font-size:13px;color:#435059;font-family:var(--noto-regular)}", ""]);
// Exports
module.exports = exports;
